import {
  Admin as RaAdmin,
  CustomRoutes,
  Resource,
  type TranslationMessages,
  resolveBrowserLocale,
  useRedirect
} from 'react-admin'
import { useMediaQuery } from '@mui/material'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import { Route, useParams, useSearchParams } from 'react-router-dom'
import log from 'loglevel'
import React from 'react'

import { ja } from './translations-ja'
import { DataProvider } from 'components/DataProvider'
import {
  OrderFormR,
  OrderCompleteFormR,
  EkycForm,
  SignForm,
  SignFormWithoutUser,
  SelectProductForm,
  GmoResult
} from 'components/OrderFormR'
import { LayoutWithoutTitle } from 'components/Layout'
import { desktopTtheme, otherTheme } from 'components/Theme'
import { isNil } from 'lodash'
import { Agreement } from 'components/Agreement'
import { customTranslates } from './customTranslate'
import { NotReady } from 'components/NotReady'
import {
  BankAccountCompleteForm,
  BankAccountForm
} from 'components/BankAccount'

log.setLevel(log.levels.DEBUG)

const translations: Record<string, TranslationMessages> = { ja }

const defaultI18nProvider = polyglotI18nProvider(
  (locale) => translations[locale] as TranslationMessages,
  resolveBrowserLocale(),
  [{ locale: 'ja', name: '日本語' }]
  // { allowMissing: true }
)

const dataProvider = DataProvider()
const RedirectToOrderFormR: React.FC<{
  setProduct: (product: string) => void
}> = ({ setProduct }) => {
  const redirect = useRedirect()
  const { product } = useParams<{ product: string }>()
  if (!isNil(product)) setProduct(product)
  const [queryParams] = useSearchParams()
  const id = queryParams.get('id')
  React.useEffect(() => {
    if (product === '84cd33c4-3ecc-4eae-879d-dfbce9707314-0') {
      redirect(`/not-ready`)
    } else if (!isNil(product)) {
      redirect(`/${product}/0${!isNil(id) ? `?id=${id}` : ''}`)
    }
  })
  return <></>
}

export const LandingPage: React.FC = () => {
  const redirect = useRedirect()
  redirect('https://www.terashite.jp/r')
  return <></>
}
export const Admin: React.FC = () => {
  const [product, setProduct] = React.useState<string | undefined>(undefined)
  const isDesktop = useMediaQuery('(min-width: 900px)')
  const i18nProvider = {
    ...defaultI18nProvider,
    translate: (key: string, options: Record<string, any>): string => {
      const { translate } = defaultI18nProvider
      if (!isNil(product)) {
        return customTranslates(product, key, options, translate)
      }
      return translate(key, options)
    }
  }
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={i18nProvider}
      lightTheme={isDesktop ? desktopTtheme : otherTheme}
      layout={LayoutWithoutTitle}>
      <Resource name="users" />
      <CustomRoutes>
        {!isNil(process.env['LOCAL']) && (
          <Route path="/" element={<OrderFormR setProduct={setProduct} />} />
        )}
        <Route path="/plans/:product" element={<SelectProductForm />} />
        <Route
          path="/:product"
          element={<RedirectToOrderFormR setProduct={setProduct} />}
        />
        <Route
          path="/:product/:page"
          element={<OrderFormR setProduct={setProduct} />}
        />
        <Route path="/:product/complete/:id" element={<OrderCompleteFormR />} />
        <Route path="/ekyc/:id" element={<EkycForm />} />
        <Route path="/sign/:id" element={<SignForm />} />
        <Route path="/signDirect/:id" element={<SignForm direct />} />
        <Route path="/sign" element={<SignFormWithoutUser />} />
        <Route path="/agreement/:id" element={<Agreement />} />
        <Route path="/gmo/:id/:result" element={<GmoResult />} />
        <Route path="/gmo/bankaccount/:id" element={<BankAccountForm />} />
        <Route
          path="/gmo/bankaccount/complete"
          element={<BankAccountCompleteForm />}
        />
        <Route path="/not-ready" element={<NotReady />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
